export const skillSet=[
	{
		softSkills:[
		"Effective communication",
		"Teamwork",
		"Responsibility",
		"Creativity",
		"Problem-solving",
		"Leadership",
		"Extroversion ",
		"People skills",
		"Openness",
		"Adaptability",
		"Interpersonal Skills",
		"Critical Thinking",
		"Public Speaking",
		"Customer Service Skills",
		"Collaboration",
		"Accounting",
		"Active Listening",
		"Negotiation",
		"Conflict Resolution",
		"Decision-making",
		"Empathy",
		"Management",
		"Organization",
		"Language skills"
		]
	},
	{
		hardSkills:{
			engineering:{
				general:[
					"Mathematics",
					"Problem-solving",
					"Experimentation",
					"Computer and technology knowledge",
					"Programming languages",
					"Technical writing",
					"Software development",
					"Computer hardware engineering",
					"Data analysis",
					"Information systems management",
					"Technical writing",
					"Linear algebra",
					"Statistics",
					"Calculus",
					"Discrete mathematics",
					"Web development",
					"Machine learning",
					"Data science",
					"Blockchain",
					"Artificial intelligence"
				],
				languages:[
					"Reactjs",
					"Python",
					"Core Java",
					"Intermediate Java",
					"Advance Java",
					"Javascript",
					"Nodejs",
					"HTML",
					"CSS",
					"Expressjs",
					"Go",
					"Swift",
					"Kotlin",
					"Ruby",
					"Scala",
					"Mysql",
					"MongoDB",
					"Sqlite",
					"PostgreSql",
					"Mysql Server",
					"Angularjs",
					"Vuejs"
				]
			}
		}
	},
	{
		management:[
			"Typing/word processing",
			"Fluency in coding languages",
			"Systems administration",
			"Spreadsheets",
			"Email management",
			"Ability to teach and mentor",
			"Flexibility",
			"Risk-taking",
			"Team building",
			"Time management",
			"Decision-making",
			"Project planning",
			"Task delegation",
			"Team communication",
			"Team leadership",
			"Attention to detail",
			"Collaboration",
			"Communication",
			"Patience",
			"Research",
			"Ambition",
			"Creativity",
			"Empathy",
			"Leadership",
			"Teamwork"
		]
	},
	{
		medical:[
			"Patient Assessment",
			"Office Skills",
			"Customer Service",
			"Taking Vital Signs",
			"Medical Administrative Skills",
			"Patient Care",
			"Recording Patient Medical History",
			"Phlebotomy Certificate",
			"Administering Injections",
			"TB Test Clearance",
			"Documentation",
			"Organizational Skills",
			"Details Oriented",
			"Phone Skills",
			"Teamwork Abilities",
			"Communication Skills",
			"Foreign Language Proficiency",
			"Nursing Skills"
		]
	}
]
export const interestSet=[
	{
		analyticalInterest:[
		"Chess",
		"Playing a musical instrument",
		"Reading",
		"Writing",
		"Sketching",
		"Photography",
		"Design",
		"Blog writing",
		"Painting"
		]
	},
	{
		socialInterest:[
		"Boardgames",
		"Creating and organizing a book club",
		"Networking events",
		"Local meetups",
		"Volunteering at a charity center",
		"Public speaking",
		"Exploring other cultures",
		"Dancing",
		"Camping ",
		"Language classes"
		]
	},
	{
		uniqueInterest:[
		"Archery",
		"Gardening",
		"Stand-up comedy",
		"Baking",
		"Journaling",
		"Calligraphy",
		"Fencing",
		"Theater",
		"Yoga",
		"Languages"
		]
	}
]
export const sampleIntro=[
	{field:"Engineering",content:"I am a dedicated, hardworking and proactive Chemical Engineer with a strong background in design, plant operations, offshore operations, and process and safety improvements. I have solid work experience in designing, testing and analysing processes to increase the overall efficiency of operations. I am currently looking for an opportunity to utilise my technical skills in a challenging working environment and become a valuable asset to the organisation that I work for"},
	{field:"Business Management",content:"I have a clear, logical mind with a practical approach to problem-solving and a drive to see things through to completion. I have more than 2 years of experience in managing and leading teams across multiple sectors. I am eager to learn, I enjoy overcoming challenges, and I have a genuine interest in Business Management and making organisations successful"},
	{field:"IT",content:"I am a highly competent IT professional with a proven track record in designing websites, networking and managing databases. I have strong technical skills as well as excellent interpersonal skills, enabling me to interact with a wide range of clients. I am eager to be challenged in order to grow and further improve my IT skills. My greatest passion is in life is using my technical know-how to benefit other people and organisations"},
	{field:"Student",content:"I am a hardworking and ambitious individual with a great passion for the transport and logistics industry. I am currently in my second year of studying BA Logistics and Supply Chain Management at Aston University. I have excellent communication skills, enabling me to effectively communicate with a wide range of people. I am seeing a part-time position in the industry in which I can put into practice my knowledge and experience, ultimately benefiting the operations of the organisation that I work for"},
	{field:"Manager",content:"I am an energetic, ambitious person who has developed a mature and responsible approach to any task that I undertake, or situation that I am presented with. As a graduate with three years’ experience in management, I am excellent in working with others to achieve a certain objective on time and with excellence. In my previous role, I improved the performance, operations and productivity of my team by 35%"},
	{field:"Sales/Retail",content:"I am a mature, positive and hardworking individual, who always strives to achieve the highest standard possible, at any given task. In my previous role as a Sales Representative, I demonstrated the ability to work under intense pressure, sell products and services to customers from all backgrounds, handle customer complaints and solve problematic situations as and when they arose. I was promoted twice for exceeding my sales targets"},
	{field:"Teaching",content:"I am a loyal, talented and caring teacher who loves making a difference in the lives of young children. I am open-minded, patient and supportive towards other people, especially towards children or those who suffer from disabilities. In my previous role as a primary school teacher, I have taught and nurtured more than 100 pupils from all backgrounds, successfully preparing them for the next stages of their young lives"},
	{field:"Designer",content:"I am a creative, artistic and ambitious Graphics Designer with a talent for thinking outside the box and coming up with innovative ideas and designs. I graduated with a 1st Class honours degree in Graphic Design from Kingston University and subsequently have worked in the design industry for the past 2 years. I pride myself in providing excellent service to all stakeholders and seeing the positive impact I make in people’s lives and businesses"},
	{field:"Media",content:"I am a professional, ambitious and highly skilled Camera Operator able to use a wide range of technical equipment, including professional cinematography camcorders. I have extensive experience working on a number of television and theatre projects, demonstrating an ability to follow artistic direction and the physical capability required on a professional production set. I am comfortable filming on-location and outside the studio with some previous work experience in live broadcasting"},
	{field:"Customer Service",content:"I am a committed, friendly and hardworking Customer Service Advisor with a passion for providing excellent customer service at all times. In my current role, I have resolved more than 150 issues, always having the needs of the customers and the reputation of the organisation at heart. I have dealt with customers’ enquiries and complaints face-to-face, over the phone and via email. My excellent customer service and communication skills, combined with my relevant work experience, make me a real asset to any organisation that I work for"},
	{field:"Science",content:"I am a creative and enthusiastic Pharmacologist with two years’ experience in the pharmaceutical industry. I have experience in designing and carrying out experiments, testing drugs, researching scientific literature and writing technical reports. I possess excellent analytical and communications skills and a dedicated approach to working in a highly controlled working environment. I am currently looking for a challenging opportunity within the science sector"},
	{field:"Healthcare",content:"I am committed, caring and friendly Physiotherapist with a great passion for helping people of all ages. I have previous experience in supporting a variety of patients ranging from children suffering from development problems to adults and the elderly affected by and recovering from injuries and movement disorders. I have excellent communication skills, both written and oral, and I enjoy working with a variety of different people"}
]